import * as React from "react";
import { AddButton } from "../../../../components";
import { BroodRequestPotentialFathersApi, EDogSex } from "../../../../api";
import { FGDogSearchInput, SmallFormGenerator } from "../../../../components";
import { ETLCodes } from "../../../../locales";
import { useApiService, useTl } from "../../../../hooks";
import { FGCustomInput, FieldGroup } from "nsitools-react";

export interface IPotentialFatherSingleSelectionProps {
  broodRequestId: number;
  linkedFatherIds: number[];
  editMode: boolean;
  motherId: number;
  onFatherAdded: () => void;
}

export const PotentialFatherSingleSelection: React.FunctionComponent<IPotentialFatherSingleSelectionProps> = ({
  broodRequestId,
  linkedFatherIds,
  editMode,
  motherId,
  onFatherAdded,
}) => {
  const { t } = useTl();
  const potentialFatherApi = useApiService(BroodRequestPotentialFathersApi);

  const addNewPotentialFather = React.useCallback(
    async (dogId: number) => {
      await potentialFatherApi.addPotentialFather(broodRequestId, dogId);
      onFatherAdded();
    },
    [broodRequestId, onFatherAdded, potentialFatherApi]
  );

  return (
    editMode && (
      <SmallFormGenerator
        initialValues={{ potentialFatherId: null }}
        minLabelWidth={600}
        editMode={editMode}
        onSubmit={() => {}}
        hideButtons={true}
      >
        <FieldGroup columns={[10, 2]}>
          <FGDogSearchInput
            name="potentialFatherId"
            defaultSearch={{
              sex: EDogSex.Male,
              removeMultipleIds: linkedFatherIds,
              filterBreeds: true,
              dogId: motherId,
              excludeExpoDogs: true,
            }}
            label={t(ETLCodes.NewPotentialFather)}
            readonly={!editMode}
          />
          <FGCustomInput>
            {(ctx) => (
              <AddButton
                minimal
                disabled={
                  ctx?.formik?.values?.potentialFatherId === null ||
                  ctx?.formik?.values?.potentialFatherId === undefined
                }
                onClick={() => addNewPotentialFather(ctx?.formik?.values?.potentialFatherId)}
              />
            )}
          </FGCustomInput>
        </FieldGroup>
      </SmallFormGenerator>
    )
  );
};
